import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import { Modal, Button, Icon, Typography } from '@cencosud-ds/bigbang';
import t from 'utils/translate';
import './style.css';

interface IModalNewVersionProps {
  isModalInfo: boolean;
  onClose: (value: boolean) => void;
  onNewAccept: () => void;
}

export default function ModalNewVersion({ isModalInfo, onClose, onNewAccept }: IModalNewVersionProps): JSX.Element {
  const markdown = `
Hemos desarrollado una nueva versión de este módulo, el cual te invitamos a visitar y probar.
  `;

  return (
    <Modal
      open={isModalInfo}
      persistent={true}
      with-blur={false}
      id="modal-example-newversion"
      onClose={() => onClose(false)}
    >
      <div className="modal__newversion">
        <div className="modal__newversion--close">
          <Button className="button-exitbutton" darkMode={true} onClick={() => onClose(false)}>
            <Icon name="Close" />
          </Button>
        </div>
        <div className="modal-newversion__containers">
          <Typography color="#166DC2" propsElement={{}} typeElement="h4" weight="bold">
            {`¡Nueva versión!`}
          </Typography>
          <ReactMarkdown className="drawer-body-markdown" linkTarget="_blank" remarkPlugins={[rehypeHighlight]}>
            {markdown}
          </ReactMarkdown>
        </div>
        <div className="modal-newversion__actions ">
          <Button type-button="primary" className="modal-newversion__button--ok" onClick={onNewAccept}>
            {t('Ir a nuevo Seller Center')}
          </Button>
          <Button type-button="secondary" className="modal-newversion__button--cancel" onClick={() => onClose(false)}>
            {t('Cancelar')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
